// A style toggle (bold, italic, underline, whole row), on the app's Button so it takes a tab stop
// and Enter/Space: the grey of secondary icons while off, and the toolbar's light blue while on.
// Off used to be text-on-solid, white, so in light mode the buttons vanished against the menu.
export const styleToggle = (on: boolean | undefined): string =>
  `flex items-center justify-center cursor-pointer rounded p-1 px-1 w-8 h-8 transition-colors ${
    on ? 'bg-really-light-blue text-blue hover:bg-light-blue' : 'text-muted hover:bg-surface-sunken hover:text-body'
  }`
